// ./das-application-steps/StepContent6.js

import React, { memo } from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";

import FormRow from "../../helpers/FormRow";

function StepContent6() {
  return (
    <div className="form-group">
      <FormRow spacing={2}>
        <Grid item xs={12}>
          <h1
            className="bold-text"
            style={{ width: "100%", textAlign: "center", marginBottom: 0 }}
          >
            District/Authority Scholarship Application
          </h1>
        </Grid>
      </FormRow>
      <FormRow spacing={2}>
        <Grid item xs={12}>
          <h2 className="bold-text">This is the end of the application.</h2>
          <p className="bold-text">
            Please remember to review and PRINT your application prior to
            submitting.
          </p>
          <p className="reg-text">
            If you are not ready to submit your application yet you can exit.
            Your application will be saved and you can log in again to continue
            editing prior to the submission deadline.
          </p>
          <p className="reg-text">
            To submit your application click “Submit Application” below.{" "}
            <span className="bold-text">
              Once your application has been submitted you will no longer be
              able to make changes.
            </span>
          </p>
          <p className="reg-text">
            Please see your school contact or call Nanaimo Ladysmith Schools
            Foundation at (250) 753-4074{" "}
            <Link href="mailto:awards@nlsf.ca?Subject=DAS Awards Application Question">
              awards@nlsf.ca
            </Link>{" "}
            if you have any questions.
          </p>
          <Paper
            elevation={2}
            sx={{
              backgroundColor: "#fffde7",
              borderLeft: "6px solid #fbc02d",
              p: 2,
              my: 2,
              fontSize: 16,
            }}
          >
            <strong style={{ color: "#b28704" }}>Important:</strong> Don’t
            forget to also apply for the
            <strong> General Scholarship</strong> and any{" "}
            <strong>Additional Donor Selected Awards</strong> for which you may
            be eligible. These are separate applications and can increase your
            chances of receiving funding. Visit{" "}
            <Link
              href="http://sas.nlsf.ca/awards-page/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "#b28704", fontWeight: 600 }}
            >
              http://sas.nlsf.ca/awards-page/
            </Link>{" "}
            for more information.
          </Paper>
        </Grid>
      </FormRow>
    </div>
  );
}

export default memo(StepContent6);
